(() => {
  const root = document.documentElement;
  const recentlySuppressed = new WeakSet();
  const modifiedElements = new Set();
  let scanScheduled = false;

  const popupSelectors = [
    '[role="dialog"][aria-label="POPUP Form"]',
    '[role="dialog"][data-kl-scroll-locking-modal="true"]',
    '#ecomsend-widget .react-responsive-modal-overlay',
    '#ecomsend-widget .pp-overlay',
    '#ecomsend-widget .spinWheelWrapper.dialogVisible',
    '.header-town-selector-modal.active',
    '#es-whatsapp-review-prompt-root.es-review-prompt-visible',
    '[role="dialog"][id*="pushowl" i]',
    '[role="dialog"][class*="pushowl" i]',
    '[role="dialog"][id*="tolstoy" i]',
    '[role="dialog"][class*="tolstoy" i]',
    'tolstoy-modal',
  ];

  const closeSelectors = [
    '[aria-label*="close" i]',
    '[aria-label*="cerrar" i]',
    '[data-testid*="close" i]',
    'button[class*="close" i]',
    '.cerrar',
    '.mas-tarde',
  ].join(',');

  function purchaseContext() {
    if (/^\/cart(?:\/|$)/.test(window.location.pathname)) return true;
    return Boolean(document.querySelector('cart-drawer.active'));
  }

  function dismissPopup(element) {
    if (recentlySuppressed.has(element)) return;
    recentlySuppressed.add(element);
    window.setTimeout(() => recentlySuppressed.delete(element), 1000);

    const close = element.querySelector(closeSelectors);
    if (close instanceof HTMLElement) close.click();

    element.setAttribute('aria-hidden', 'true');
    element.setAttribute('data-gotta-purchase-suppressed', 'true');
    modifiedElements.add(element);
  }

  function protectPurchaseFlow() {
    const active = purchaseContext();
    root.classList.toggle('gotta-purchase-flow-active', active);

    if (!active) {
      modifiedElements.forEach((element) => {
        if (element.isConnected) {
          element.removeAttribute('aria-hidden');
          element.removeAttribute('data-gotta-purchase-suppressed');
        }
      });
      modifiedElements.clear();
      return;
    }

    document.querySelectorAll(popupSelectors.join(',')).forEach(dismissPopup);
    document.querySelectorAll('.header-town-selector-modal.active').forEach((modal) => modal.classList.remove('active'));
    document.querySelectorAll('.location-overlay.active').forEach((overlay) => overlay.classList.remove('active'));
    document.body?.classList.remove('location-modal-open');
  }

  function scheduleProtection() {
    if (scanScheduled) return;
    scanScheduled = true;
    window.requestAnimationFrame(() => {
      scanScheduled = false;
      protectPurchaseFlow();
    });
  }

  function start() {
    protectPurchaseFlow();
    new MutationObserver(scheduleProtection).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden'],
    });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
